<template>
<div class="chapter">
<div class="inner_page">
<h2 class="ch-no"><span class="b-bold">Table of Contents</span></h2>
<p class="toc-fm"><a href="#/xhtml/fm04"><em class="italic">Introduction</em></a></p>
<p class="toc-chapter"><span href="#/xhtml/chap01" title="Link target outside of Sample"><span class="toc-no">Chapter 1</span> Should I Stay or Should I Go?</span></p>
<p class="toc-chapter"><span href="#/xhtml/chap02" title="Link target outside of Sample"><span class="toc-no">Chapter 2</span> If I’m So Smart, Why Is This Hard?</span></p>
<p class="toc-chapter"><span href="#/xhtml/chap03" title="Link target outside of Sample"><span class="toc-no">Chapter 3</span> Combat the Success Trap: Prepare Like the Pros</span></p>
<p class="toc-chapter"><span href="#/xhtml/chap04" title="Link target outside of Sample"><span class="toc-no">Chapter 4</span> Focus on One Job, Become Attractive to Many</span></p>
<p class="toc-chapter"><span href="#/xhtml/chap05" title="Link target outside of Sample"><span class="toc-no">Chapter 5</span> Five Stories That Every Candidate Needs to Nail</span></p>
<p class="toc-chapter"><span href="#/xhtml/chap06" title="Link target outside of Sample"><span class="toc-no">Chapter 6</span> Make Your Stories Come to Life</span></p>
<p class="toc-chapter"><span href="#/xhtml/chap07" title="Link target outside of Sample"><span class="toc-no">Chapter 7</span> Sometimes What You Don’t Say Speaks the Loudest</span></p>
<p class="toc-chapter"><span href="#/xhtml/chap08" title="Link target outside of Sample"><span class="toc-no">Chapter 8</span> How to Leave a Lasting Impression</span></p>
<p class="toc-chapter"><span href="#/xhtml/chap09" title="Link target outside of Sample"><span class="toc-no">Chapter 9</span> When (Not If) Things Get Hard</span></p>
<p class="toc-chapter"><span href="#/xhtml/chap10" title="Link target outside of Sample"><span class="toc-no">Chapter 10</span> Yes, And! What’s Next?</span></p>
<p class="toc-fm"><span href="#/xhtml/bm01" title="Link target outside of Sample"><em class="italic">Further Reading</em></span></p>
<p class="toc-fm"><span href="#/xhtml/bm02" title="Link target outside of Sample"><em class="italic">Acknowledgments</em></span></p>
<p class="toc-fm"><span href="#/xhtml/bm03" title="Link target outside of Sample"><em class="italic">About the Author</em></span></p>
<p class="toc-fm"><span href="#/xhtml/bm04" title="Link target outside of Sample"><em class="italic">Thank You</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?80592364